const Prospeccion = () => {
  return (
    <>
      <div>
        <p className="p-0 m-0 text-center text-sm-left h4 font-weight-bold">
          EN PROSPECCIÓN
        </p>
        <hr></hr>
        <div className="pl-5 pt-3 pr-5">
          <p className="p-0 m-0 h6 font-weight-bold">TEJADOS O CUBIERTAS</p>
          <hr></hr>

          <p>
            Buscamos tejados o cubiertas de grandes dimensiones en régimen de
            alquiler para realizar instalaciones solares fijas.
          </p>
          <p className="p-0 mt-5 m-0 h6 font-weight-bold">
            TERRENOS - HUERTOS SOLARES
          </p>
          <hr></hr>

          <p>
            En la situación actual, con la nueva normativa y la incertidumbre en
            el sector, consideramos que es difícil ofrecer un producto atractivo
            con instalaciones de estas características, debido a que los cupos
            están ampliamente superados para los próximos meses o años. La única
            posibilidad que vemos para promocionar instalaciones sobre suelo en
            breve seria si podemos adquirir terreno con permisos ya concedidos.
          </p>
        </div>
      </div>
    </>
  );
};

export default Prospeccion;
